exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-body[data-v-5fad3c78] {\n  overflow: inherit;\n}\n", ""]);

// exports
